import { useId } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const CopyIcon = ({
  size,
  color = "currentColor",
  ...svgProps
}) => {
  const maskId = useId();
  return /*#__PURE__*/jsxs("svg", {
    ...svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14",
    style: {
      ...svgProps.style,
      width: `${(typeof size === "number" ? size : size.width).toString()}px`,
      height: `${(typeof size === "number" ? size : size.height).toString()}px`
    },
    fill: "none",
    children: [/*#__PURE__*/jsx("mask", {
      id: maskId,
      fill: "#fff",
      children: /*#__PURE__*/jsx("rect", {
        width: "9",
        height: "11",
        rx: "1"
      })
    }), /*#__PURE__*/jsx("rect", {
      width: "9",
      height: "11",
      rx: "1",
      stroke: color,
      strokeWidth: "2",
      vectorEffect: "non-scaling-stroke",
      mask: `url(#${maskId})`
    }), /*#__PURE__*/jsx("path", {
      d: "M11 3v9c0 .5523-.4477 1-1 1H3",
      stroke: color,
      strokeWidth: "1",
      vectorEffect: "non-scaling-stroke"
    })]
  });
};

export { CopyIcon };
//# sourceMappingURL=CopyIcon.js.map
